export default __webpack_public_path__ + "static/media/Engineering-Img.e7f5ebf8.gif";